module.exports = {
  confidenceBar: {
    title: '30 years of making holidays better',
    cards: [
      {
        title: 'Tried, tested and recommended',
        image: '<svg height="50" width="50" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 490.2 490.2" style="enable-background:new 0 0 490.2 490.2;" xml:space="preserve"><g><path d="M490.1,234.464c0-37.6-30.6-68.3-68.3-68.3H316.2v-76.1c0-32.2-9.4-55.4-28-69c-29.4-21.6-69.8-9.3-71.5-8.7c-5.1,1.6-8.6,6.3-8.6,11.7v85.5c0,67.3-78.1,90.2-81.4,91.2c-1,0.3-1.9,0.6-2.7,1.1c-5.8-11.6-17.8-19.6-31.6-19.6H35.2c-19.4,0-35.2,15.8-35.2,35.2v207.9c0,19.4,15.8,35.2,35.2,35.2h33.1c6.8,0,12.3-5.5,12.3-12.3s-5.6-12.2-12.3-12.2H35.2c-5.9,0-10.7-4.8-10.7-10.7v-207.9c0-5.9,4.8-10.7,10.7-10.7h57.3c5.9,0,10.7,4.8,10.7,10.7v196.1c0,37.6,30.6,68.3,68.3,68.3h209.2c46.4,0,75.9-24.3,81.1-66.3l28.2-177c0.1-0.6,0.2-1.3,0.2-1.9v-2.2H490.1z M465.6,235.564l-28.1,176.5c-3.7,30-22.8,45.3-56.8,45.3h-7.8H171.5c-24.1,0-43.8-19.6-43.8-43.8v-189.1c1.8,0.4,3.7,0.3,5.6-0.2c4.1-1.1,99.3-28.7,99.3-114.8v-75.6c10.4-1.6,28.2-2.5,41.1,6.9c11.9,8.8,18,25.3,18,49.3v88.4c0,6.8,5.5,12.3,12.3,12.3h117.9c24.1,0,43.8,19.6,43.8,43.8v1H465.6z"></path></g></svg>',
        content: 'We\'ve slept in every hotel and parked in every car park we sell. We know our partners are as dedicated as we are to making your holiday hassle-free.'
      },
      {
        title: 'Never beaten on price',
        image: '<svg height="50" width="50" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 481.195 481.195" style="enable-background:new 0 0 481.195 481.195;" xml:space="preserve"><g><path d="M180.116,308.298l78.5,23.8c-0.1,0.5-0.3,1.1-0.5,1.6c-2.1,5.7-6.4,8.9-13.4,10c-25.8,4.1-68.6,1.5-69,1.5c-6.6-0.4-12.3,4.6-12.7,11.2s4.6,12.3,11.2,12.7c1.9,0.1,45.8,2.8,74.3-1.8c28.3-4.5,36.4-29.4,34.9-45.1c-0.5-4.9-3.8-9-8.5-10.4l-87.9-26.6c-43.4-13.1-91,11.1-93,12.1c-0.2,0.1-0.5,0.2-0.7,0.4l-87.5,52.9c-5.7,3.4-7.5,10.8-4.1,16.5c2.3,3.7,6.2,5.8,10.3,5.8c2.1,0,4.2-0.6,6.2-1.7l87.1-52.5C109.116,316.698,147.416,298.398,180.116,308.298z"></path><path d="M479.716,288.198c-6.9-12.6-28.4-32.7-61-18.3c-30.8,13.7-95.9,45-96.6,45.3c-6,2.9-8.5,10-5.6,16s10.1,8.5,16,5.6c0.7-0.3,65.4-31.5,95.9-45c8.7-3.9,16-3.9,22.3,0c0.2,0.1,0.3,0.2,0.5,0.3l-163.1,119.5c-11.6,8.5-26.3,12-40.4,9.8l-145.5-23.2c-3.4-0.5-6.9,0.4-9.6,2.6l-36.8,30.7c-5.1,4.2-5.8,11.8-1.5,16.9c2.4,2.8,5.8,4.3,9.2,4.3c2.7,0,5.4-0.9,7.7-2.8l32.6-27.2l140.2,22.4c20.4,3.3,41.7-1.9,58.4-14.1l174-127.4C481.116,299.998,482.616,293.498,479.716,288.198z"></path><path d="M257.416,274.398c18.7,0,36.2-7.3,49.5-20.5c27.3-27.3,27.3-71.6,0-98.9c-13.2-13.2-30.8-20.5-49.5-20.5c-18.7,0-36.2,7.3-49.5,20.5c-27.3,27.3-27.3,71.6,0,98.9C221.216,267.098,238.716,274.398,257.416,274.398z M224.916,171.998c8.7-8.7,20.2-13.5,32.5-13.5c12.3,0,23.8,4.8,32.5,13.5c17.9,17.9,17.9,47.1,0,65c-8.7,8.7-20.2,13.5-32.5,13.5c-12.3,0-23.8-4.8-32.5-13.5C207.016,219.098,207.016,189.898,224.916,171.998z"></path><path d="M339.516,137.698c14.6,0,28.3-5.7,38.6-16c21.3-21.3,21.3-55.9,0-77.2c-10.3-10.3-24-16-38.6-16s-28.3,5.7-38.6,16c-21.3,21.3-21.3,55.9,0,77.2C311.216,132.098,325.016,137.698,339.516,137.698z M317.916,61.498c5.8-5.8,13.5-9,21.7-9s15.9,3.2,21.7,9c11.9,11.9,11.9,31.4,0,43.3c-5.8,5.8-13.5,9-21.7,9s-15.9-3.2-21.7-9C306.016,92.798,306.016,73.398,317.916,61.498z"></path></g></svg>',
        content: 'You can be confident that Holiday Extras prices will never be beaten but in the unlikely event you find the same product for less somewhere else, we will match the price, guaranteed. </span><a href="/never-beaten-on-price.html" >Terms and conditions</a> apply.</p>'
      },
      {
        title: '4+ million bookings',
        image: '<svg height="50" width="50" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 423.803 423.803" style="enable-background:new 0 0 423.803 423.803;" xml:space="preserve"><g><path d="M422.951,368.901l-16.8-58.4c-0.4-1.2-1.2-2.4-2-3.2c-10.4-31.6-36-56-68.4-64.4l-4.8-0.8c-7.2-2-15.2,0.4-20.4,6.4c-17.6,20-40,21.6-63.6,21.6c-23.6,0-46-1.6-63.6-21.6c-5.2-6-13.2-8.4-20.4-6.4l-4.8,1.2c-24.4,6.4-45.2,22-58.4,42.8h-50.4c-0.4,0-0.4,0-0.8-0.4c0-0.4-0.4-0.8-0.4-1.6l10.4-37.2c9.2-29.2,26.8-38,61.2-46.8c1.6-0.4,2.8-1.2,3.6-2c2.8,2.4,6,4.4,9.2,6c1.2,0.8,2.4,0.8,3.6,0.8c2.8,0,5.6-1.6,7.2-4.4c2-4,0.4-8.8-3.6-10.8c-18.4-9.6-31.6-36.8-31.6-64.8c0-24.8,20.4-45.2,45.2-45.2c4.8,0,9.2,0.8,13.6,2c-4.4,10.8-6.8,22.4-6.8,34.8c0,68.4,41.2,126,90,126c48,0,90.4-58.8,90.4-126c0-50-40.4-90.4-90.4-90.4c-31.6,0-59.6,16.4-75.6,41.2c-6.8-2.4-14-3.6-21.2-3.6c-21.6,0-40.8,11.6-51.6,28.8c-0.8-0.8-1.6-1.2-2.4-1.6c-6-3.2-12-4.4-18.8-4.4c-22.4-0.4-40.4,17.6-40.4,40c0,12.8,3.6,24.8,9.2,34.4c-18.4,4.8-34.8,12-42.4,36.4l-6.4,23.2c-1.2,4-0.4,8.4,2,11.6c2.4,3.6,6.8,5.6,11.2,5.6h30.8c-0.4,1.6-1.2,3.2-1.6,4.8l-10.4,37.6c-1.6,5.2-0.4,10.8,3.2,15.2c3.2,4.4,8,6.8,13.6,6.8h42.4c-1.2,2.8-2,5.6-2.8,8.4l-16.8,58.8c-1.6,6.8-0.4,14,4,19.6c4.4,5.6,10.8,8.8,17.6,8.8h240h13.6h54c6.8,0,13.6-3.2,17.6-8.8C423.351,383.301,424.951,376.101,422.951,368.901z M184.151,82.901c0.4-0.4,0.8-0.8,1.2-1.6c0.4-0.4,0.4-1.2,0.8-1.6c12.4-22.4,36.4-37.6,64-37.6c33.2,0,61.2,22,70.8,52c-14,2.8-28.8-2.8-37.6-14.8c-2.8-3.6-7.6-4.4-11.2-1.6c-1.6,1.2-2.4,2.4-2.8,4c-0.4,0.4-0.4,0.8-0.8,1.2c-11.2,22.8-48.8,32.4-91.6,24C178.151,98.501,180.551,90.501,184.151,82.901z M206.551,125.701c32,0,58.4-10,72-28.8c10,8.8,22.4,13.6,35.6,13.6c3.2,0,6.8-0.4,10-1.2c0.4,2.4,0.4,4.4,0.4,6.8c0,58.8-34.8,110.4-74.4,110.4c-38,0-71.2-47.6-74-103.6C186.551,124.901,196.951,125.701,206.551,125.701z M16.951,221.701l5.6-20c4.8-16.4,14.8-21.2,34.8-26c1.2-0.4,2.4-0.8,3.2-1.6c2,1.6,3.6,2.8,6,4c1.2,0.8,2.4,0.8,3.6,0.8c2.8,0,5.6-1.6,7.2-4.4c2-4,0.4-8.8-3.2-10.8c-10.4-5.6-18-21.2-18-37.2c0-13.6,10.8-24.4,24.4-24.4c4.4,0,8,0.8,11.6,2.8c1.2,0.4,2,0.8,3.2,0.8c-2,6-3.2,12.4-3.2,19.2c0,22.8,7.6,45.2,19.6,60.8c-24,6-45.2,14-59.2,36H16.951z M406.551,379.301c-0.8,0.8-2.4,2.4-5.2,2.4h-54h-13.6h-240c-2.8,0-4.4-1.6-5.2-2.4c-1.2-1.6-1.6-4-1.2-5.6l16.8-58.4c8-27.6,30-49.2,58-56.4l4.8-1.2c1.2-0.4,3.2,0.4,4.4,1.6c22,25.2,49.2,27.2,75.6,27.2c26.4,0,53.6-2,75.6-27.2c1.2-1.2,2.8-2,4.8-1.6l4.8,1.2c27.6,7.2,50,28.8,58,56.4l7.2,24.8c0.4,1.2,0.8,2,1.6,2.8l8.8,30.4C408.151,375.301,407.751,377.701,406.551,379.301z"></path></g></svg>',
        content: 'Over 4 million bookings last year and the number is rising. We would like to thank all of our customers who keep on returning.'
      },
      {
        title: 'Expert customer service',
        image: '<svg height="50" width="50" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 416 416" style="enable-background:new 0 0 416 416;" xml:space="preserve"><g><g><g><path d="M256,160h-12c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8h12c4.4,0,8-3.6,8-8C264,163.6,260.4,160,256,160z"></path><path d="M208,160h-60c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8h60c4.4,0,8-3.6,8-8C216,163.6,212.4,160,208,160z"></path><path d="M336,112H148c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8h188c4.4,0,8-3.6,8-8C344,115.6,340.4,112,336,112z"></path><path d="M376,32H104c-22,0-40,18-40,40v88H24c-13.2,0-24,10.8-24,24v128c0,13.2,10.8,24,24,24h40v40c0,3.2,2,6,4.8,7.2c1.2,0.4,2,0.8,3.2,0.8c2,0,4-0.8,5.2-2l49.6-44l0.4-0.4c1.2-1.2,2.8-1.6,5.2-1.6h52c13.2,0,24-10.8,24-24v-56h7.2c6,0,11.6,2,16,6.4l74.8,69.2c1.6,1.2,3.6,2,5.6,2c1.2,0,2-0.4,3.2-0.8c2.8-1.2,4.8-4,4.8-7.2V256h56c22,0,40-18,40-40V72C416,50,398,32,376,32z M192.4,312c0,4.4-3.6,8-8,8h-52c-6.4,0-12,2-16.4,6l-36,32v-30c0-4.4-3.6-8-8-8H24c-4.4,0-8-3.6-8-8V184c0-4.4,3.6-8,8-8h40v40c0,22,18,40,40,40h88.4V312z M400,216c0,13.2-10.8,24-24,24h-56v-24c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8v91.2l-61.2-56.8c-7.2-6.8-16.8-10.4-27.2-10.4H104c-13.2,0-24-10.8-24-24V72c0-13.2,10.8-24,24-24h272c13.2,0,24,10.8,24,24V216z"></path></g></g></g></svg>',
        content: 'We\'ve 150 experts in Kent whose mission is to ensure your call or live chat will be answered within 20 seconds or your email within 15 minutes.'
      }
    ]
  },
  europeanBar: {
    title: 'Holiday Extras Europe',
    subtitle: 'Travelling from a different country? We have websites all over Europe.',
    target: 'Links open in a new window',
    countries: [
      {
        name: 'Austria',
        countryCode: 'at'
      },
      {
        name: 'France',
        countryCode: 'fr'
      },
      {
        name: 'Netherlands',
        countryCode: 'nl'
      },
      {
        name: 'Czech Republic',
        countryCode: 'cz'
      },
      {
        name: 'Germany',
        countryCode: 'de'
      },
      {
        name: 'Poland',
        countryCode: 'pl'
      },
      {
        name: 'Denmark',
        countryCode: 'dk'
      },
      {
        name: 'Italy',
        countryCode: 'it'
      },
      {
        name: 'Switzerland',
        countryCode: 'ch'
      }
    ]
  },
  creditsBar: {
    socialLinks: [
      {
        url: 'http://www.facebook.com/HolidayExtras',
        icon: 'facebook',
        name: 'Holiday Extras on Facebook'
      }, {
        url: 'http://www.flickr.com/photos/holiday-extras',
        icon: 'flickr',
        name: 'Holiday Extras on Flickr'
      }, {
        url: 'https://plus.google.com/107580011434424823041',
        icon: 'google-plus',
        name: 'Holiday Extras on Google+'
      }, {
        url: 'https://twitter.com/#!/HolidayExtras',
        icon: 'twitter',
        name: 'Holiday Extras on Twitter'
      }, {
        url: 'http://www.youtube.com/holidayextras',
        icon: 'youtube',
        name: 'Holiday Extras on Youtube'
      }
    ],
    creditLinks: [
      {
        name: 'Agent Login',
        url: 'https://www.holidayextras.co.uk/login.php',
        meta: {
          rel: 'no-follow',
          target: '_parent'
        }
      },
      {
        name: 'Terms & Conditions',
        url: '/about-us/terms-and-conditions.html'
      },
      {
        name: 'Privacy Policy',
        url: '/about-us/privacy-policy.html'
      },
      {
        name: 'Sitemap',
        url: '/sitemap/sitemap.html'
      }
    ],
    address: 'Holiday Extras Ltd. Ashford Road, Newingreen, Kent, CT21 4JF.',
    registered: 'Holiday Extras Ltd. Company registered in England and Wales (01693250). Office registered at Ashford Road, Newingreen, Kent, UK, CT21 4JF'
  },
  linksBar: {
    search: 'Search Holiday Extras',
    signUp: 'Sign Up',
    searchPlaceholder: 'Search',
    searchPath: '/search.html',
    cantFindWhatImLookingFor: 'Can\'t find what you\'re looking for? Enter a search term below.',
    established: 'HolidayExtras.com, established in 1983, is the UK market leader in pre-booked UK airport hotels and parking.',
    landingPageFooterLinks: [
      {
        title: 'Holiday Extras',
        links: [
          {
            link: '/about-us/about-us.html',
            text: 'About'
          }, {
            link: '/about-us/contact-us.html',
            text: 'Contact'
          }, {
            link: 'http://partnerwith.holidayextras.co.uk/',
            text: 'Partner with us'
          }, {
            link: 'http://join.holidayextras.co.uk',
            text: 'Careers'
          }, {
            link: 'http://www.holidayextras.co.uk/hxblog.html',
            text: 'Holiday Extras Blog'
          }, {
            link: '/affiliate-introduction.html',
            text: 'Affiliate scheme'
          }, {
            link: 'http://press-office.holidayextras.co.uk/',
            text: 'Press office'
          }, {
            link: '/news-archive.html',
            text: 'News archive'
          }, {
            link: '/about-us/privacy-policy.html',
            text: 'Privacy / Cookie Policy'
          }
        ]
      }, {
        title: 'Bookings',
        links: [
          {
            link: 'https://help.holidayextras.co.uk/',
            text: 'FAQs'
          }, {
            link: '/help-with-new-booking.html',
            text: 'New booking enquiry'
          }, {
            link: '/details-form-resend.html',
            text: 'Resend confirmation'
          }, {
            link: '/details-form-cancel.html',
            text: 'Cancel a booking'
          }, {
            link: '/details-form-amend.html',
            text: 'Amend a booking'
          }, {
            link: '/help-existing-booking.html',
            text: 'Help with an existing booking'
          }, {
            link: 'https://v2.holidayextras.co.uk/users/edit',
            text: 'View bookings'
          }, {
            link: '/about-us/cancellation-charges-waiver.html',
            text: 'Cancellation waiver'
          }, {
            link: '/never-beaten-on-price.html',
            text: 'Never beaten on price'
          }
        ]
      }, {
        title: 'Getting To The Airport',
        links: [
          {
            link: '/airport-parking.html',
            text: 'Airport parking'
          }, {
            link: '/airport-hotels.html',
            text: 'Airport hotels'
          }, {
            link: '/airport-lounges.html',
            text: 'Airport lounges'
          }, {
            link: '/airports-by-rail.html',
            text: 'Airports by rail'
          }, {
            link: 'http://www.heha.com',
            text: 'HEHA! Trip Planner'
          }, {
            link: '/parking-in-london.html',
            text: 'London parking'
          }, {
            link: '/taxitotheairport.html?launch_id=FT',
            text: 'Taxi to the airport'
          }, {
            link: '/airport-weather.html',
            text: 'Weather update'
          }, {
            link: '/theatre-breaks.html',
            text: 'London theatre breaks'
          }
        ]
      }, {
        title: 'For The Trip',
        links: [
          {
            excludeFlag: 'InsuranceBookings',
            link: '/travel-insurance.html',
            text: 'Travel insurance'
          }, {
            link: '/car-hire.html?launch_id=FT',
            text: 'Holiday car hire'
          }, {
            link: '/holiday-checklist.html',
            text: 'Holiday checklist'
          }, {
            link: '/airport-hand-luggage-and-security.html',
            text: 'Luggage &amp; security'
          }, {
            link: '/travel-money.html?launch_id=FT',
            text: 'Travel money'
          }, {
            link: '/travel-shop.html',
            text: 'Travel shop'
          }, {
            link: '/flight.html',
            text: 'Flight information'
          }, {
            link: '/destinations.html',
            text: 'Holiday destinations'
          }, {
            link: '/airport-transfers.html',
            text: 'Airport transfers'
          }, {
            link: '/business-traveller.html',
            text: 'Business traveller'
          }
        ]
      }, {
        title: 'Airport Parking',
        links: [
          {
            link: '/gatwick-airport-parking.html',
            text: 'Gatwick parking'
          }, {
            link: '/heathrow-airport-parking.html',
            text: 'Heathrow parking'
          }, {
            link: '/stansted-airport-parking.html',
            text: 'Stansted parking'
          }, {
            link: '/luton-airport-parking.html',
            text: 'Luton airport parking'
          }, {
            link: '/manchester-airport-parking.html',
            text: 'Manchester airport parking'
          }, {
            link: '/birmingham-airport-parking.html',
            text: 'Birmingham airport parking'
          }, {
            link: '/cardiff-airport-parking.html',
            text: 'Cardiff airport parking'
          }, {
            link: '/liverpool-airport-parking.html',
            text: 'Liverpool airport parking'
          }, {
            link: '/glasgow-airport-parking.html',
            text: 'Glasgow airport parking'
          }, {
            link: '/bristol-airport-parking.html',
            text: 'Bristol airport parking'
          }
        ]
      }, {
        title: 'Airport Hotels',
        links: [
          {
            link: '/gatwick-airport-hotels.html',
            text: 'Gatwick hotels'
          }, {
            link: '/sofitel-gatwick-airport-hotel.html',
            text: 'Sofitel Gatwick'
          }, {
            link: '/heathrow-airport-hotels.html',
            text: 'Heathrow hotels'
          }, {
            link: '/airport-hotels/heathrow/sofitel.html',
            text: 'Heathrow Sofitel'
          }, {
            link: '/stansted-airport-hotels.html',
            text: 'Stansted hotels'
          }, {
            link: '/luton-airport-hotels.html',
            text: 'Luton airport hotels'
          }, {
            link: '/manchester-airport-hotels.html',
            text: 'Manchester airport hotels'
          }, {
            link: '/birmingham-airport-hotels.html',
            text: 'Birmingham airport hotels'
          }, {
            link: '/cardiff-airport-hotels.html',
            text: 'Cardiff airport hotels'
          }, {
            link: '/liverpool-airport-hotels.html',
            text: 'Liverpool airport hotels'
          }, {
            link: '/glasgow-airport-hotels.html',
            text: 'Glasgow airport hotels'
          }, {
            link: '/bristol-airport-hotels.html',
            text: 'Bristol airport hotels'
          }
        ]
      }
    ]
  }
}
